module.exports = __webpack_public_path__ + "static/media/Shop-By-Tire-Size-White.c0386b34.svg";